module.exports = __webpack_public_path__ + "static/media/GardenPavilion.6caf05ff.jpg";